export default __webpack_public_path__ + "static/media/lynx.1c6da61c.jpg";